import React, { Component } from 'react';
import logo from '../../logo.svg';
import './index.css';

import { Form } from '../Form';
import { List } from '../List';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React Context Reducer</h1>
          <p>A global store implementation with react context API, useReducer and other hooks</p>
        </header>

        <p className="App-intro">
          To get started, edit <code>src/index.js</code> and save to reload.
        </p>

        <Form />
        <List />
      </div>
    );
  }
}

export default App;
